export function readEmbedUrl(
  metadata: Record<string, unknown> | null | undefined,
): string | null {
  if (!metadata) return null;
  const value = metadata.embed_url;
  return typeof value === "string" ? value : null;
}
